import React, { useEffect, useState } from 'react';
import { equalTo, get, onValue, orderByChild, push, query, ref, set } from 'firebase/database';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { db } from '../../fb';
import {
    Container,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    Snackbar,
    Alert,
    Typography,
    Box,
    CircularProgress,
    ListItemIcon,
    Checkbox,
    Divider,
    ListItemText,
} from '@mui/material';
import BackButton from '../BackButton';
import { Close } from '@mui/icons-material';

const PublicarConcursoDesk = ({ user }) => {
    const [formData, setFormData] = useState({
        titulo: '',
        entidade: user.nome,
        objeto: '',
        condicoes: '',
        documentacao: '',
        prazo: '',
        localEntrega: '',
        dataAbertura: '',
        criterios: '',
        valorEstimado: '',
        condicoesPagamento: '',
        observacoes: '',
        provincia: [],
        setor: '',
        tipoEntidade: [],
        company: user,
        anexos: [],
        timestamp: new Date().toISOString(),
        requisitosTecnicos: '',
        modalidade: '',
        numeroReferencia: '',
    });

    const [richTextData, setRichTextData] = useState({
        objeto: '',
        condicoes: '',
        documentacao: '',
        criterios: '',
        condicoesPagamento: '',
        observacoes: '',
    });

    const [loading, setLoading] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [provincias, setProvincias] = useState([]);
    const [sectores, setSectores] = useState([]);
    const [tiposEntidades, setTiposEntidades] = useState([]);
    const [openProvinciaSelect, setOpenProvinciaSelect] = useState(false);
    const [selectedProvincias, setSelectedProvincias] = useState([]);
    const [openTipoEntidadeSelect, setOpenTipoEntidadeSelect] = useState(false);

    useEffect(() => {
        const provinciasRef = ref(db, 'provincias');
        const sectoresRef = ref(db, 'sectores_de_atividade');
        const tipoEntidadeRef = ref(db, 'tipos_entidades');

        onValue(provinciasRef, (snapshot) => {
            const provinciasData = snapshot.val() || [];
            setProvincias(provinciasData);
        });

        onValue(sectoresRef, (snapshot) => {
            const sectoresData = snapshot.val() || [];
            setSectores(sectoresData);
        });

        onValue(tipoEntidadeRef, (snapshot) => {
            const tipoEntidadeData = snapshot.val() || [];
            setTiposEntidades(tipoEntidadeData);
        });
    }, []);

    const handleRichTextChange = (field, value) => {
        setRichTextData({ ...richTextData, [field]: value });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const formatCurrency = (value) => {
        if (!value) return '';
        
        // Remove qualquer caractere que não seja número
        const numericValue = value.replace(/\D/g, '');
      
        // Converte para número float dividido por 100
        const floatValue = parseFloat(numericValue) / 100;
      
        // Formata para estilo português (pt-PT)
        return floatValue.toLocaleString('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

    const handleValorChange = (e) => {
        const { name, value } = e.target;
      
        const formattedValue = formatCurrency(value);
      
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: formattedValue,
        }));
      };

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        setFormData((prevState) => ({
            ...prevState,
            anexos: [...prevState.anexos, ...files],
        }));
    };
    const handleProvinciaChange = (event) => {
        const value = event.target.value;
        
        // Se selecionou "Todas"
        if (value.includes("all")) {
            if (selectedProvincias.length === provincias.length) {
                setSelectedProvincias([]);
            } else {
                setSelectedProvincias(provincias.map(p => p.provincia));
            }
            return;
        }
        
        setSelectedProvincias(value);
    };

    const handleCloseProvinciaSelect = () => {
        setOpenProvinciaSelect(false);
    };

    const handleOpenProvinciaSelect = () => {
        setOpenProvinciaSelect(true);
    };

    // Atualize o formData quando selectedProvincias mudar
    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            provincia: selectedProvincias
        }));
    }, [selectedProvincias]);

    const handleTipoEntidadeChange = (event) => {
        const value = event.target.value;
        setFormData(prev => ({
            ...prev,
            tipoEntidade: Array.isArray(value) ? value : [value]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
    
        // Validação dos campos obrigatórios
        if (!formData.titulo || !formData.prazo || !formData.localEntrega || !formData.setor || !formData.modalidade) {
            setSnackbarMessage('Por favor, preencha todos os campos obrigatórios.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            setLoading(false);
            return;
        }

        // Validação das províncias
        if (!formData.provincia || formData.provincia.length === 0) {
            setSnackbarMessage('Por favor, selecione pelo menos uma província.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            setLoading(false);
            return;
        }

        // Validação do tipo de entidade
        if (!formData.tipoEntidade || formData.tipoEntidade.length === 0) {
            setSnackbarMessage('Por favor, selecione pelo menos um tipo de entidade.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            setLoading(false);
            return;
        }

        // Validação da data do prazo
        const prazoDate = new Date(formData.prazo);
        const hoje = new Date();
        if (prazoDate <= hoje) {
            setSnackbarMessage('O prazo deve ser uma data futura.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            setLoading(false);
            return;
        }

        // Validação do valor estimado
        if (formData.valorEstimado) {
            const valorNumerico = parseFloat(formData.valorEstimado.replace(/[^\d,]/g, '').replace(',', '.'));
            if (isNaN(valorNumerico) || valorNumerico <= 0) {
                setSnackbarMessage('O valor estimado deve ser um número positivo.');
                setSnackbarSeverity('error');
                setOpenSnackbar(true);
                setLoading(false);
                return;
            }
        }
    
        const sanitizedData = Object.fromEntries(
            Object.entries({
                ...formData,
                ...richTextData,
                user: user?.uid,
                dataCriacao: new Date().toISOString(),
                timestamp: new Date().toISOString(),
                status: 'Aberta',
                company: {
                    id: user?.id,
                    nome: user?.nome,
                    logoUrl: user?.logoUrl
                },
                provincia: Array.isArray(formData.provincia) ? formData.provincia : [formData.provincia],
                tipoEntidade: Array.isArray(formData.tipoEntidade) ? formData.tipoEntidade : [formData.tipoEntidade]
            }).filter(([_, v]) => v !== undefined && v !== null && v !== '')
        );

        console.log('Dados a serem salvos:', sanitizedData);
    
        try {
            const concursosRef = ref(db, 'concursos');
            const newConcursoRef = push(concursosRef);
    
            const concursoId = newConcursoRef.key;
    
            const concursoWithId = {
                ...sanitizedData,
                id: concursoId,
            };
    
            console.log('Tentando salvar concurso com ID:', concursoId);
    
            // Salvando o concurso com o ID no banco de dados
            await set(newConcursoRef, concursoWithId);
            console.log('Concurso salvo com sucesso');
    
            // Notificar empresas do setor
            try {
                await notifySectorCompanies(
                    formData.setor, 
                    formData.titulo, 
                    richTextData.objeto, 
                    formData.prazo, 
                    formData.valorEstimado, 
                    formData.localEntrega
                );
            } catch (notifyError) {
                console.error('Erro ao notificar empresas:', notifyError);
                // Não interrompe o fluxo se a notificação falhar
            }
    
            setSnackbarMessage('Concurso publicado com sucesso!');
            setSnackbarSeverity('success');
            setOpenSnackbar(true);
    
            // Limpar o formulário após o envio
            setFormData({
                titulo: '',
                entidade: user.nome,
                objeto: '',
                condicoes: '',
                documentacao: '',
                prazo: '',
                localEntrega: '',
                dataAbertura: '',
                criterios: '',
                valorEstimado: '',
                condicoesPagamento: '',
                observacoes: '',
                provincia: [],
                setor: '',
                tipoEntidade: [],
                company: user,
                anexos: [],
                requisitosTecnicos: '',
                modalidade: '',
                numeroReferencia: '',
            });
    
            setRichTextData({
                objeto: '',
                condicoes: '',
                documentacao: '',
                criterios: '',
                condicoesPagamento: '',
                observacoes: '',
            });

            // Redirecionar após 2 segundos para dar tempo do usuário ver a mensagem de sucesso
            setTimeout(() => {
                window.location.href = "/concursos";
            }, 2000);

        } catch (error) {
            console.error('Erro detalhado ao publicar concurso:', error);
            setSnackbarMessage(`Erro ao publicar concurso: ${error.message || 'Erro desconhecido'}`);
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    
    const notifySectorCompanies = async (sector, title, description, deadline, valorEstimado, localEntrega) => {
        const empresasRef = ref(db, 'company');
        const setorQuery = query(empresasRef, orderByChild('sector'), equalTo(sector));
        const snapshot = await get(setorQuery);
        if (snapshot.exists()) {
            const empresas = snapshot.val();
            for (const key in empresas) {
                const empresa = empresas[key];
                const message = `Novo concurso no seu setor:\n\nTítulo: ${title}\nDescrição: ${description}\nValor Estimado: ${valorEstimado}\nLocal de Entrega: ${localEntrega}\nData Limite: ${deadline}`;
                const to = empresa.contacto;
                await sendMessage(message, to);
            }
        }
    };

    const sendMessage = async (message, to) => {
        try {
            const response = await axios.post('http://localhost:3001/send-sms', {
                message,
                to,
            });
            if (response.data.success) {
                setSnackbarMessage('Mensagem enviada com sucesso pelo WhatsApp!');
                setSnackbarSeverity('success');
                setOpenSnackbar(true);
            }
        } catch (error) {
            setSnackbarMessage('Erro ao enviar mensagem pelo WhatsApp.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            console.error('Erro ao enviar mensagem pelo WhatsApp:', error);
        }
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    return (
        <Container>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3, backgroundColor:'#FFF', padding:'12px' }}>
            <BackButton sx={{ mb: 2 }} />
                <Typography variant="h4" gutterBottom>
                    Publicar Concurso
                </Typography>

                <TextField
                    fullWidth
                    label="Título do Concurso"
                    name="titulo"
                    value={formData.titulo}
                    onChange={handleChange}
                    required
                    margin="normal"
                />

                <TextField
                    fullWidth
                    label="Número de Referência"
                    name="numeroReferencia"
                    value={formData.numeroReferencia}
                    onChange={handleChange}
                    required
                    margin="normal"
                />

                <TextField
                    fullWidth
                    label="Prazo de Apresentação de Propostas"
                    type="date"
                    name="prazo"
                    value={formData.prazo}
                    onChange={handleChange}
                    required
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                />

                <TextField
                    fullWidth
                    label="Contato (Telefone/E-mail)"
                    name="contato"
                    value={formData.contato}
                    onChange={handleChange}
                    margin="normal"
                />

                <FormControl fullWidth margin="normal">
                    <InputLabel>Categoria</InputLabel>
                    <Select
                        name="categoria"
                        value={formData.categoria}
                        onChange={handleChange}
                        label="Categoria"
                    >
                        <MenuItem value="">Selecione a Categoria</MenuItem>
                        <MenuItem value="Obras Públicas">Obras Públicas</MenuItem>
                        <MenuItem value="Serviços">Serviços</MenuItem>
                        <MenuItem value="Fornecimentos">Fornecimentos</MenuItem>
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <InputLabel>Modalidade de Concurso</InputLabel>
                    <Select
                        name="modalidade"
                        value={formData.modalidade}
                        onChange={handleChange}
                        label="Modalidade de Concurso">
                        <MenuItem value="">Selecione a Modalidade</MenuItem>
                        <MenuItem value="Concurso Público">Concurso Público</MenuItem>
                        <MenuItem value="Concurso Privado">Concurso Privado</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    fullWidth
                    type="file"
                    name="anexos"
                    inputProps={{ multiple: true }}
                    onChange={handleFileUpload}
                    margin="normal"/>
                <TextField
                    fullWidth
                    label="Local de Entrega"
                    name="localEntrega"
                    value={formData.localEntrega}
                    onChange={handleChange}
                    required
                    margin="normal"/>
                <FormControl fullWidth margin="normal">
                    <InputLabel>Província(s) abrangidas pelo concurso</InputLabel>
                    <Select
                        multiple
                        name="provincia"
                        value={selectedProvincias}
                        onChange={handleProvinciaChange}
                        onClose={handleCloseProvinciaSelect}
                        onOpen={handleOpenProvinciaSelect}
                        open={openProvinciaSelect}
                        label="Província(s)"
                        required
                        renderValue={(selected) => selected.join(', ')}
                    >
                        {/* Opção "Todas" */}
                        <MenuItem value="all">
                            <ListItemIcon>
                                <Checkbox
                                    checked={selectedProvincias.length === provincias.length}
                                    indeterminate={
                                        selectedProvincias.length > 0 && 
                                        selectedProvincias.length < provincias.length
                                    }
                                />
                            </ListItemIcon>
                            <ListItemText primary="Todas as Províncias" />
                        </MenuItem>

                        {/* Opção "Fechar" */}
                        <MenuItem onClick={handleCloseProvinciaSelect}>
                            <ListItemIcon>
                                <Close fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Fechar" />
                        </MenuItem>

                        <Divider />

                        {/* Lista de províncias */}
                        {provincias.map((provinciaObj, index) => (
                            <MenuItem key={index} value={provinciaObj.provincia}>
                                <Checkbox checked={selectedProvincias.includes(provinciaObj.provincia)} />
                                <ListItemText primary={provinciaObj.provincia} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="normal">
                    <InputLabel>Setor de Atividade</InputLabel>
                    <Select
                        name="setor"
                        value={formData.setor}
                        onChange={handleChange}
                        label="Setor de Atividade"
                        required>
                        <MenuItem value="">Selecione o Setor</MenuItem>
                        {sectores.map((setorObj, index) => (
                            <MenuItem key={index} value={setorObj.setor}>
                                {setorObj.setor}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
  <InputLabel>Tipo de Entidade *</InputLabel>
  <Select
    multiple
    name="tipoEntidade"
    value={formData.tipoEntidade}
    onChange={(e) => {
      // Handle "Select All" case
      if (e.target.value.includes("all")) {
        if (formData.tipoEntidade.length === tiposEntidades.length) {
          // If all are already selected, deselect all
          handleTipoEntidadeChange({
            target: {
              name: "tipoEntidade",
              value: [],
            },
          });
        } else {
          // Select all tipos
          handleTipoEntidadeChange({
            target: {
              name: "tipoEntidade",
              value: tiposEntidades.map(t => t.tipo),
            },
          });
        }
      } else {
        // Normal selection
        handleTipoEntidadeChange(e);
      }
    }}
    label="Tipo de Entidade *"
    required
    renderValue={(selected) => selected.join(', ')}
    open={openTipoEntidadeSelect}
    onClose={() => setOpenTipoEntidadeSelect(false)}
    onOpen={() => setOpenTipoEntidadeSelect(true)}
  >
    <MenuItem onClick={() => setOpenTipoEntidadeSelect(false)}>
      <ListItemIcon>
        <Close fontSize="small" />
      </ListItemIcon>
      <ListItemText primary="Fechar" />
    </MenuItem>
    <MenuItem value="all">
      <ListItemIcon>
        <Checkbox
          checked={formData.tipoEntidade.length === tiposEntidades.length && tiposEntidades.length > 0}
          indeterminate={
            formData.tipoEntidade.length > 0 && 
            formData.tipoEntidade.length < tiposEntidades.length
          }
        />
      </ListItemIcon>
      <ListItemText primary="Selecionar Todos" />
    </MenuItem>
    <Divider />

    {tiposEntidades.map((tipoObj, index) => (
      <MenuItem key={index} value={tipoObj.tipo}>
        <Checkbox checked={formData.tipoEntidade.includes(tipoObj.tipo)} />
        <ListItemText primary={tipoObj.tipo} />
      </MenuItem>
    ))}
  </Select>
</FormControl>

                <TextField
                    fullWidth
                    label="Data de Abertura das Propostas"
                    type="date"
                    name="dataAbertura"
                    value={formData.dataAbertura}
                    onChange={handleChange}
                    required
                    margin="normal"
                    InputLabelProps={{ shrink: true }}/>
               <TextField
                    fullWidth
                    label="Valor Estimado do Contrato"
                    name="valorEstimado"
                    value={formData.valorEstimado}
                    onChange={handleValorChange}
                    required
                    margin="normal"
                    inputProps={{ 
                        maxLength: 20,
                        inputMode: 'numeric',
                    }}
                    />
                <Typography variant="h6" gutterBottom>
                    Objeto do Concurso
                </Typography>
                <ReactQuill
                    value={richTextData.objeto}
                    onChange={(value) => handleRichTextChange('objeto', value)}/>

                <Typography variant="h6" gutterBottom>
                    Condições de Participação
                </Typography>
                <ReactQuill
                    value={richTextData.condicoes}
                    onChange={(value) => handleRichTextChange('condicoes', value)}/>

                <Typography variant="h6" gutterBottom>
                    Documentação Necessária
                </Typography>
                <ReactQuill
                    value={richTextData.documentacao}
                    onChange={(value) => handleRichTextChange('documentacao', value)}/>

                <Typography variant="h6" gutterBottom>
                    Critérios de Avaliação
                </Typography>
                <ReactQuill
                    value={richTextData.criterios}
                    onChange={(value) => handleRichTextChange('criterios', value)}/>

                <Typography variant="h6" gutterBottom>
                    Condições de Pagamento
                </Typography>
                <ReactQuill
                    value={richTextData.condicoesPagamento}
                    onChange={(value) => handleRichTextChange('condicoesPagamento', value)}/>

                <Typography variant="h6" gutterBottom>
                    Observações
                </Typography>
                <ReactQuill
                    value={richTextData.observacoes}
                    onChange={(value) => handleRichTextChange('observacoes', value)}/>

                <Button type="submit" variant="contained" color="primary" sx={{ mt: 3 }} disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : 'Publicar Concurso'}
                </Button>
            </Box>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default PublicarConcursoDesk;